import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Grid,
  Text,
  BlockStack,
  InlineStack,
  Icon,
  Page,
  Layout,
  Button,
} from "@shopify/polaris";
import {
  ArrowRightIcon,
  QuestionCircleIcon,
  OrderRepeatIcon,
  StoreFilledIcon,
  OrdersStatusIcon,
  OrderFulfilledIcon,
  PointOfSaleIcon,
  StarIcon,
  ChevronUpIcon,
} from "@shopify/polaris-icons";
import AppLayout from "../containers/layout";
import {
  RiCarLine,
  RiCoupon4Line,
  RiCoupon5Line,
  RiCouponFill,
  RiCouponLine,
  RiHome2Line,
  RiHomeSmile2Line,
  RiIdCardFill,
} from "react-icons/ri";

const Dashboard = () => {
  const navigate = useNavigate();
  const menuItems = [
    {
      title: "Inquiries",
      path: "/inquiries",
      icon: QuestionCircleIcon,
      tone: "info",
    },
    {
      title: "Reorder",
      path: "/reorder",
      icon: OrderRepeatIcon,
      tone: "success",
    },
    {
      title: "Sellers",
      path: "/sellers",
      icon: StoreFilledIcon,
      tone: "warning",
    },
    {
      title: "Cancel Order",
      path: "/cancel-order",
      icon: OrdersStatusIcon,
      tone: "critical",
    },
    {
      title: "Order Update",
      path: "/order-update",
      icon: OrderFulfilledIcon,
      tone: "critical",
    },
    {
      title: "Birthday Sale",
      path: "/birthday-sale",
      icon: PointOfSaleIcon,
      tone: "critical",
    },
    {
      title: "Winners",
      path: "/winners",
      icon: StarIcon,
      tone: "critical",
    },
    {
      title: "Coupon Code",
      path: "/coupon-code",
      icon: RiCouponLine,
      tone: "critical",
    },
    {
      title: "Coupon Card",
      path: "/couponcard",
      icon: RiIdCardFill,
      tone: "critical",
    },
        {
      title: "Expert Workshop",
      path: "/expert-workshop",
      icon: RiHomeSmile2Line,
      tone: "critical",
    },
  ];

  return (
    <AppLayout>
      <Page fullWidth>
        <Layout>
          <Layout.Section>
            <BlockStack gap="400">
              <Text as="h1" variant="headingLg" alignment="center">
                Welcome to Dashboard
              </Text>

              <Grid
                columns={{ xs: 1, sm: 2, md: 2, lg: 3 }}
                gap={{ xs: "400", lg: "300" }}
              >
                {menuItems.map((item) => (
                  <Grid.Cell key={item.path}>
                    <Card
                      onClick={() => navigate(item.path)}
                      background="bg-surface"
                      padding="400"
                      rounded="200"
                      borderColor="border"
                      shadow="200"
                      tone={item.tone}
                    >
                      <div className="group relative h-full min-h-[180px] cursor-pointer transition-all duration-300 hover:-translate-y-1  rounded-lg">
                        <BlockStack
                          gap="300"
                          align="center"
                          onClick={() => navigate(`${item.path}`)}
                        >
                          <div className="flex justify-center">
                            <div className="rounded-full bg-surface-secondary p-4 transition-colors group-hover:bg-surface-tertiary">
                              <div className="store-page">
                                {item.title === "Coupon Code" ? (
                                  <RiCouponLine size={28} />
                                ) : item.title === "Coupon Card" ? (
                                  <RiCoupon4Line size={30} /> 
                                ) : item.title === "Expert Workshop" ? (
                                  <RiHomeSmile2Line size={30} />
                                ) : (
                                  <Icon source={item.icon} tone="base" />
                                )}
                              </div>
                            </div>
                          </div>

                          <BlockStack align="center">
                            <Text
                              as="h2"
                              variant="headingLg"
                              alignment="center"
                            >
                              {item.title}
                            </Text>
                          </BlockStack>

                          <div className="absolute bottom-4 right-4 opacity-0 transition-opacity group-hover:opacity-100">
                            <Button
                              variant="tertiary"
                              onClick={() => navigate(`${item.path}`)}
                            >
                              <InlineStack gap="200" align="center">
                                {/* <Badge tone={item.tone}>Go</Badge> */}
                                <Icon source={ArrowRightIcon} tone="base" />
                              </InlineStack>
                            </Button>
                          </div>
                        </BlockStack>
                      </div>
                    </Card>
                  </Grid.Cell>
                ))}
              </Grid>
            </BlockStack>
          </Layout.Section>
        </Layout>
      </Page>
    </AppLayout>
  );
};

export default Dashboard;
